import React from 'react';

import type { TransactionActorAddress } from '../../../generated-types';
import TransactionLineSkeleton from './TransactionLineSkeleton';

type Props = {
    label: string;
    address?: TransactionActorAddress;
    isLoading?: boolean;
};

const TransactionActorAddressField: React.FC<Props> = ({ label, address, isLoading = false }) => {
    if (isLoading) {
        return <TransactionLineSkeleton />;
    }

    if (!address || !Object.entries(address)?.length) return <></>;

    return (
        <div className="transaction-details__detail">
            <div className="transaction-details__detail-label" data-testid="transaction-detail-labels">
                {label}
            </div>
            <p className="transaction-details__detail-data">
                <span className="transaction-details__receiver-address">
                    {address.addressLine1 && <span>{address.addressLine1}</span>}
                    {address.addressLine2 && <span>{address.addressLine2}</span>}
                    {address.town && address.postalCode && (
                        <span>
                            {address.postalCode} {address.town}
                        </span>
                    )}
                    {address.country && <span>{address.country}</span>}
                </span>
            </p>
        </div>
    );
};

export default TransactionActorAddressField;
